import { graphql, useStaticQuery } from 'gatsby';

const useSiteMetadata = () => {
  const { site } = useStaticQuery(
    graphql`
      query SITE_METADATA_QUERY {
        site {
          siteMetadata {
            title
            siteUrl
            menuLinks {
              title
              link
              links {
                title
                link
              }
              pre
              description
            }
          }
        }
      }
    `
  );
  return site.siteMetadata;
};

/*
"title": "Portfolio",
        "description": "of Jussi Vanto",
        "link": "/portfolio/",
        "links": 

*/

export default useSiteMetadata;